import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
  import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
  import { UtilHelper } from '../../../_helpers/util';
  import { environment } from '../../../../environments/environment';
  import { OdsService } from '../../../services/service.index';
  declare var toastr;

@Component({
  selector: 'app-permiso',
  templateUrl: './permiso.component.html',
  styles: []
})
export class PermisoComponent implements OnInit {
      @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
      dataResourcePR: any[];
      model: any = {
        id: 0,
        codigo: '',
        titulo: '',
        descripcion: '',
        activo: true,
        vigente: false
      };
      id: number;
      popupVisibleAdd: boolean = false;
      popupVisibleDel: boolean = false;
      state_toogle: boolean = false;
      vigencia: any[];
      baseUrl = environment.apiEndpoint;
      hasError: any;
    
      constructor(private _ss: OdsService) {
        this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
        this.clearErrors();
        this.getParametricas();
      }
    
      ngOnInit() {
      }
    
      clearErrors() {
        this.hasError = { codigo: false, descripcion: false, titulo: false };
      }
    
      getParametricas() {
        this._ss.getParametricas().subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.dataResourcePR = result.data;
            } else {
              this.dataResourcePR = [];
            }
          },
          (error) => {
            console.log('Error', error);
          });
      }
    
      onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
          location: 'before',
          template: 'acciones'
        });
      }        
    
      showModalChange(id: number) {        
        this.model.id = id;
        this.popupVisibleDel = true;
      }
    
      onValueChanged() {      
        this._ss.putPermiso(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getParametricas();
              this.popupVisibleDel = false;          
              toastr.success('Proceso realizado correctamente.');          
            } else {           
              this.getParametricas();   
              this.popupVisibleDel = false;          
              toastr.warning(result.data);   
            }
          },
          error => { console.log('Error', error); });
      }  
 
     

    }
    